module.exports = __webpack_public_path__ + "static/img/kanarekwr.1f591848.webp";